// extracted by mini-css-extract-plugin
export var addToCartButton = "_q6-b";
export var arrowButtonContainer = "_q6-9";
export var arrowButtonIcon = "_q6-a";
export var carouselArrowButton = "_q6-6";
export var carouselElementContainer = "_q6-1";
export var left = "_q6-7";
export var productDisplayCarouselContainer = "_q6-0";
export var productTileContainer = "_q6-2";
export var productTileImage = "_q6-4";
export var productTileImageContainer = "_q6-3";
export var productTileTitle = "_q6-5";
export var right = "_q6-8";
export var sliderOverflow = "_q6-c";